export const locale = {
  lang: 'de',
  data: {
    'WIZARD': {
      'TESTTITULO': 'ASSISTENTENTITEL :V',
      'CARGANDO': 'Erworbene Produkte laden',
      'CARGANDO_PULSOS': 'Ladeimpulse in Bearbeitung',
      'SINPRODS': 'Sie haben dieses Produkt nicht erworben',
      'EVALUADOR':{
        'TITUTLO':'Auswerter'
      },
      'LANDING': {
        'PRODUCTO': {
          'CERTIFICAR':{
            'TITULO': 'Willkommen bei CULTURAL GO!',
            'CURRENT': 'Dies ist Ihr aktueller Umfrageprozess',
            'FINISHED': 'Dies ist ein abgeschlossener Befragungsprozess',
            'RESULTS': {
              'CURRENT': 'Umfrageprozess nicht beendet',
              // 'FINISHED': 'Finished survey process'
              'FINISHED': 'Dies ist Ihr aktueller Umfrageprozess',
              'FINISHED5': 'Ergebnisse verarbeiten'
            }
          },
          'Amco':{
            'TITULO': 'WILLKOMMEN BEI AMCO',
            'CURRENT': 'Dies ist der aktuelle amco-Prozess',
            'FINISHED': 'Dies ist ein abgeschlossener amco-Prozess',
            'RESULTS': {
              'CURRENT': 'Amco-Prozess nicht beendet',
              'FINISHED': 'Dies ist der aktuelle Ergebnisprozess',
              'FINISHED5': 'Ergebnisprozess',
            }
          },
          'Trabajo_digno':{
            'TITULO': 'WILLKOMMEN BEI DER MENSCHENWÜRDIGEN ARBEIT',
            'CURRENT': 'Dies ist der aktuelle Prozess für menschenwürdige Arbeit',
            'FINISHED': 'Dies ist ein abgeschlossener Prozess für menschenwürdige Arbeit',
            'RESULTS': {
              'CURRENT': 'Decent work process not finished.',
              'FINISHED': 'Dies ist der aktuelle Ergebnisprozess',
              'FINISHED5': 'Ergebnisprozess',
            }
          },
          'Primer_empleo':{
            'TITULO': 'WILLKOMMEN IM ERSTEN ARBEITSVERHÄLTNIS',
            'CURRENT': 'Dies ist der aktuelle Vorgang der ersten Beschäftigung',
            'FINISHED': 'Dies ist ein abgeschlossener Erstbeschäftigungsprozess.',
            'RESULTS': {
              'CURRENT': 'First employment process not completed',
              'FINISHED': 'Dies ist der aktuelle Ergebnisprozess',
              'FINISHED5': 'Ergebnisprozess',
            }
          },
          'CERTIFICAR_ESPAIN':{
            'CURRENT': 'Dies ist Ihr aktueller Umfrageprozess',
            'FINISHED': 'Dies ist ein beendeter Umfrageprozess',
            'RESULTS': {
              'CURRENT': 'Umfragevorgang nicht beendet',
              // 'FINISHED': 'Beendeter Umfrageprozess'
              'FINISHED': 'Dies ist Ihr aktueller Umfrageprozess',
              'FINISHED5': 'Ergebnisse verarbeiten'
            }
          },
          'CERTIFICAR_C1':{
            'TITULO': 'Willkommen bei CULTURAL GO!',
            'CURRENT': 'Dies ist Ihr aktueller Umfragevorgang',
            'FINISHED': 'Dies ist ein beendeter Umfragevorgang',

            //ESPAÑA
            'TITULO_ESPAIN': 'Willkommen bei CULTURAL GO!',
            'RESULTS': {
              'CURRENT': 'Umfragevorgang nicht beendet',
              // 'FINISHED': 'Beendeter Umfragevorgang'
              'FINISHED': 'Dies ist Ihr aktueller Umfrageprozess',
              'FINISHED5': 'Ergebnisse verarbeiten'
            }
          },

          'CERTIFICAR_C2':{
            'TITULO': 'Willkommen bei CULTURAL GO!',
            'CURRENT': 'Dies ist Ihr aktueller Umfragevorgang',
            'FINISHED': 'Dies ist ein beendeter Umfrageprozess',
            'RESULTS': {
              'CURRENT': 'Umfragevorgang nicht beendet',
              // 'FINISHED': 'Beendeter Umfrageprozess'
              'FINISHED': 'Dies ist Ihr aktueller Umfrageprozess'
            }
          },
          'CERTIFICAR_C3':{
            'TITULO': 'Willkommen bei CULTURAL GO!',
            'CURRENT': 'Dies ist Ihr aktueller Umfrageprozess',
            'FINISHED': 'Dies ist ein beendeter Umfrageprozess',
            'RESULTS': {
              'CURRENT': 'Umfragevorgang nicht beendet',
              // 'FINISHED': 'Beendeter Umfrageprozess'
              'FINISHED': 'Dies ist Ihr aktueller Umfrageprozess',
              'FINISHED5': 'Ergebnisse verarbeiten'
            }
          },
          'CERTIFICAR_C4':{
            'TITULO': 'WILLKOMMEN BEI DER SILBERZERTIFIZIERUNG',
            'CURRENT': 'Dies ist Ihr aktueller Umfrageprozess',
            'FINISHED': 'Dies ist ein beendeter Umfrageprozess',
            'RESULTS': {
              'CURRENT': 'Umfragevorgang nicht beendet',
              // 'FINISHED': 'Beendeter Umfrageprozess'
              'FINISHED': 'Dies ist Ihr aktueller Umfrageprozess',
              'FINISHED5': 'Ergebnisse verarbeiten'
            }
          },

          'MEDIR':{
            'TITULO': 'WILLKOMMEN ZUR MESSUNG',
            'CURRENT': 'Dies ist Ihr aktueller Messvorgang',
            'FINISHED': 'Dies ist ein beendeter Messvorgang',
            'RESULTS': {
              'CURRENT': 'Messvorgang nicht beendet',
              // 'FINISHED': 'Beendeter Messvorgang'
              'FINISHED': 'Dies ist Ihr aktueller Messprozess',
              'FINISHED5': 'Prozessergebnisse'

            }
          },
          'MEDIR_M1':{
            'TITULO': 'WILLKOMMEN ZUR MESSUNG ERWEITERT',
            'CURRENT': 'Dies ist Ihr aktueller Messvorgang',
            'FINISHED': 'Dies ist ein beendeter Messvorgang',
            'RESULTS': {
              'CURRENT': 'Messvorgang nicht beendet',
              'FINISHED': 'Beendeter Messvorgang'
            }
          },
          'MEDIR_M2':{
            'TITULO': 'WILLKOMMEN ZUR MESSUNG + MST',
            'CURRENT': 'Dies ist Ihr aktueller Messvorgang',
            'FINISHED': 'Dies ist ein beendeter Messvorgang',
            'RESULTS': {
              'CURRENT': 'Messvorgang nicht beendet',
              'FINISHED': 'Beendeter Messvorgang'
            }
          },
          'MEDIR_M3':{
            'TITULO': 'WILLKOMMEN ZUR MESSUNG NACH BEREICHEN',
            'CURRENT': 'Dies ist Ihr aktueller Messvorgang',
            'FINISHED': 'Dies ist ein beendeter Messvorgang',
            'RESULTS': {
              'CURRENT': 'Messvorgang nicht beendet',
              'FINISHED': 'Beendeter Messvorgang'
            }
          },
          'MEDIR_M4':{
            'TITULO': 'WILLKOMMEN ZUR MESSUNG DURCH FÜHRUNGSKRÄFTE',
            'CURRENT': 'Dies ist Ihr aktueller Messprozess',
            'FINISHED': 'Dies ist ein abgeschlossener Messprozess',
            'RESULTS': {
              'CURRENT': 'Messvorgang nicht beendet',
              'FINISHED': 'Beendeter Messvorgang'
            }
          },
          'MEDIR_M5':{
            'TITULO': 'WILLKOMMEN ZUM MESSEN NACH MASS',
            'CURRENT': 'Dies ist Ihr aktueller Messvorgang',
            'FINISHED': 'Dies ist ein beendeter Messvorgang',
            'RESULTS': {
              'CURRENT': 'Messvorgang nicht beendet',
              'FINISHED': 'Beendeter Messvorgang'
            }
          },
          'MEDIR_M6':{
            'TITULO': 'WILLKOMMEN ZUR MESSUNG ZUR ZERTIFIZIERUNG',
            'CURRENT': 'Dies ist Ihr aktueller Messvorgang',
            'FINISHED': 'Dies ist ein beendeter Messvorgang',
            'RESULTS': {
              'CURRENT': 'Messvorgang nicht beendet',
              'FINISHED': 'Beendeter Messvorgang'
            }
          },
          'PULSE':{
            'TITULO': 'WILLKOMMEN BEI PULSE CHECK',
            'ADMINTITULO': 'ADMINISTRATOR PULSE CHECK',
            'PRODU': 'Impulsprüfung',
            'CURRENT': 'Dies ist Ihr aktueller Pulse Check-Prozess',
            'PULSOS': 'Dies ist ein Pulse Check-Prozess',
            'FINISHED': 'Dies ist ein beendeter Pulse-Check-Prozess',
            'ENTRAR': 'Start',
            'CARGANDO_PULSE':'Lade Pulskontrollen in Bearbeitung',
            'RESULTS': {
              'CURRENT': 'Pulse Check Prozess nicht beendet',
              // 'FINISHED': 'Beendeter Pulse Check Prozess'
              'FINISHED': 'Dies ist Ihr aktueller Pulse Check Prozess'
            }
          },
          'FOCUS':{
            'SECTION': 'Gruppen-Administrator',
            'TITLE': 'Gruppen-Administrator',
            'SUBTI': 'Auswahl oder Erstellung von Gruppen',
            'LAND': {
              'NAME': 'Name der Umfrage',
              'INICIO': 'Startdatum',
              'FIN': 'Zieldatum',
              'AVANCE': 'Vorlauf',
              'ESTADO': 'Status',
              'COMP': 'Verhalten',
              'CREARENC': 'Umfrage erstellen',
              'LÖSCHEN': 'Löschen',
              'EDIT': 'Bearbeiten',
            },
            'TITULO': 'WILLKOMMEN IM FOKUSBEREICH',
              'CURRENT': 'Dies ist Ihr aktueller Fokusbereichsprozess',
              'FINISHED': 'Dies ist ein beendeter Fokusbereichsprozess',
              'RESULTS': {
                'CURRENT': 'Fokusbereichsprozess nicht beendet',
                'FINISHED': 'Beendeter Fokusbereichsprozess'
              }
            },
          'FOCUS_1':{
            'SECTION': 'Gruppen-Administrator',
            'TITLE': 'Gruppen-Administrator',
            'SUBTI': 'Auswahl oder Erstellung von Gruppen',
            'ADMINTITULO': 'ADMINISTRATOR-FOKUSBEREICHE',
            'PRODU': 'Fokusbereich',
            'CARGANDO_FOCUS':'Laden des Fokusbereichs in Bearbeitung',
            'TAB_PROC_FOC':'Fokusbereich Prozesse',
            'TAB_SUBIDA_COLB_FOC':'Mitarbeiter-Upload',
            'INST_MOD_FILTER_1':'Hochladen der Liste der Mitwirkenden',
            'INST_MOD_FILTER_2':'Geben Sie die Umfrage Ihrer Wahl ein',
            'LAND': {
              'NAME': 'Name der Umfrage',
              'INICIO': 'Startdatum',
              'FIN': 'Zieldatum',
              'AVANCE': 'Vorlauf',
              'ESTADO': 'Status',
              'COMP': 'Verhalten',
              'CREARENC': 'Umfrage erstellen',
              'LÖSCHEN': 'Löschen',
              'EDIT': 'Bearbeiten',
            },
            'TITULO': 'WILLKOMMEN IM FOKUSBEREICH',
              'CURRENT': 'Dies ist Ihr aktueller Fokusbereichsprozess',
              'FINISHED': 'Dies ist ein beendeter Fokusbereichsprozess',
              'RESULTS': {
                'CURRENT': 'Fokusbereichsprozess nicht beendet',
                'FINISHED': 'Beendeter Fokusbereichsprozess'
              }
            },
            'MEDIR_M9':{
              'TITULO': 'WILLKOMMEN BEI INNMOTION SURVEY',
              'CURRENT': 'Dies ist Ihr aktueller Fokusbereichsprozess',
              'FINISHED': 'Dies ist ein beendeter Fokusbereichsprozess',
              'RESULTS': {
                'CURRENT': 'Fokusbereichsprozess nicht beendet',
                'FINISHED': 'Beendeter Fokusbereichsprozess'
              }
            },

        },
            'DONE': 'Anwendungsjahr: ',
            'LEGA': 'Erhebungsergebnisse',
            'FOKUS': 'UMFRAGE ZU FOKUSBEREICH',
            'ENTRAR': 'Start',
            'IR': 'Los',
            ////instituto turquia///
            'INST-TURQUEY':{
              'TITULO':'Kultur Brief ve Culture Audit 5.0',
              'TITULO-1':'Kultur Brief ve Culture Audit 5.0',
              'TITULO1':'Kultur Brief ve Culture Audit 5.0',
              'TITULO2':'Kultur Brief 5.0',
              'TITULO3':'Kultur Audit 5.0',
              'TITULO4':'Besondere Liste',

            },
            'INST-CHINA':{
              'TITULO':'Kultur Audit',
              'TITULO1':'Kultur-Audit',
              'TITULO2':'Kultur Audit 5.0',
              'TITULO3':'Kultur Audit SP',
            },
            'INST-ESP':{
              'TITULO':'Kultur Audit',
              'TITULO1':'Kultur Audit',
              'TITULO2':'Kultur Audit 5.0',
              'TITULO3':'Aktionsplan',
            }
          },
          'STEPSTAT': {
            'LOCK': 'Schritt gesperrt',
            'PEND': 'Schritt offen',
            'COMP': 'Schritt beendet'
          },
          'NOPRODUCTS': {
            'TITULO': 'Ihr Unternehmen hat keine erworbenen Produkte',
            'SUBTI': 'Informationen zum Angebot'
          },
          'GUIA35': {
            'TITULO': 'Leitfaden NOM-035-STPS-2018',
            'SUBTITULO': 'Beschreibung',
            'DESCRIPCION': 'Informationen zu NOM-035-STPS-2018',
            'ENTRAR': 'START'
          },
          'ENCUESTA35': {
            'TITULO': 'Umfragen NOM-035-STPS-2018',
            'TITULO2': 'Pollster NOM-035-STPS-2018',
            'SUBTITULO':'Beschreibung',
            'DESCRIPCION': 'Der folgende Abschnitt gehört zu einem Umfrager von NOM-035-STPS-2018, in dem die verschiedenen psychosozialen Risikofaktoren im organisatorischen Umfeld von Arbeitnehmern identifiziert werden sollen',
            'ENTRAR': 'START'
          },
          'CERTIFICAR_ESPAIN': {
            'TITULO': 'Diagnose',
          },
          'Amco': {
            'TITULO': 'Amco',
          },
          'Trabajo_digno': {
            'TITULO': 'Menschenwürdige Arbeit',
          },
          'Primer_empleo': {
            'TITULO': 'Erste Arbeit',
          },
          'NOM35V3': {
              'TITULO': 'Norm 035 3.0'
          },
          'CERTIFICAR_C4': {
              'TITULO': 'Silbernes Zertifikat'
          },
          'CERTIFICAR': {
            'TITULO': 'Zertifizieren',
            'TITULO_ESPAIN': 'Diagnose',
            'STEPS': {
              'STP1': {
                'WIZBT': 'Sprachen',
                'TITULO': 'Sprachen',
                'SUBTI': 'Sprachenauswahl'
              },
              'STP_NPS': {
                'WIZBT': 'NPS',
                'TITULO': 'NPS',
                'SUBTI': 'NPS Ausgabe'
              },
              'STP1-1': {
                'WIZBT': 'Anweisungen',
                'TITULO': 'Anweisungen',
                'SUBTI': 'Anweisungen bearbeiten'
              },
              'STP1-FOCUS-PLANTILLA': {
                'WIZBT': 'Schablonen',
                'TITULO': 'Schablonen',
                'SUBTI': 'Anweisungen bearbeiten'
              },
              'STP2': {
                'WIZBT': 'Für alle Praxen',
                'TITULO': 'Für alle Praxen',
                'SUBTI': 'Für alle Praxen Ihres Unternehmens für die Umfrage einfügen'
              },
              'STP_CONTROL': {
                'WIZBT': 'Kontrollfrage',
                'TITULO': 'Kontrollfrage',
                'SUBTI': 'Bearbeitung der Kontrollfrage'
              },
              'STP3': {
                'WIZBT': 'Demografie',
                'TITULO': 'Demographie',
                'SUBTI': 'Fügen Sie die demografischen Informationen ein, die in der Umfrage angezeigt werden sollen. HINWEIS: Demografische Angaben in gelb sind optional'
              },
              'STP3-1': {
                'WIZBT': 'Offene Fragen',
                'TITULO': 'Offene Fragen',
                'SUBTI': 'Einfügen der offenen Fragen'
              },
              'STP4': {
                'WIZBT': 'Verkaufshilfsmittel',
                'TITULO': 'Verkaufshilfsmittel',
                'SUBTI': 'Zusatzfragen für die Umfrage einfügen'
              },
              'STP4-FOCUS-PLANTILLA': {
                'WIZBT': 'Personalisiert',
                'TITULO': 'Personalisiert',
                'SUBTI': 'Personalisierte Fragen für die Umfrage einfügen'
              },
              'STP4-1': {
                'WIZBT': 'Umfrage generieren',
                'TITULO': 'Umfrage generieren',
                'SUBTI': 'Umfrage generieren',
                'WIZBT2': 'Umfrage',
                'TITULO2': 'Umfrage',
              },
              'STP5': {
                'WIZBT': 'Teilnehmer',
                'TITULO': 'Teilnehmer',
                'SUBTI': 'Laden Sie Ihre Firmen-Teilnehmer-Mitarbeiter-Datenbank hoch'
              },
              'STP6': {
                'WIZBT': 'Umfrage terminieren',
                'TITULO': 'Zeitplan für die Umfrage',
                'SUBTI': 'Start- und Erinnerungsdaten der Umfrage einplanen'
              },
              'STP7': {
                'WIZBT': 'Mail-Absender',
                'TITULO': 'Mail-Absender',
                'SUBTI': 'Senden Sie die Umfrageeinladung an Ihre Pilotteilnehmer'
              },
              // 'STP8': {
              // 'WIZBT': 'Umfrage abschließen',
              // 'TITULO': 'Umfrageabschluss',
              // 'SUBTI': 'Fortschritt vor Abschluss der Umfrage'
              // },
              'STP8': {
                'WIZBT': 'Umfrage-Nachbereitung',
                'TITULO': 'Umfrage-Nachbereitung',
                'SUBTI': 'Fortschritte vor Abschluss der Umfrage'
              },
              'STP9': {
                'WIZBT': 'Umfrage aktivieren',
                'TITULO': 'Umfrage aktivieren',
                'SUBTI': 'Aktiviere die Umfrage'
              },
              'STP10': {
                'WIZBT': 'Vorlage',
                'TITULO': 'Änderungen an der Vorlage vornehmen',
                'SUBTI': 'Vorlage'
              },
              'STP_VOICE': {
                'WIZBT': 'Spracheinstellungen',
                'TITULO': 'Legen Sie die Spracheinstellungen für die Umfrage mit Audio fest',
                'SUBTI': 'Legen Sie die Spracheinstellungen für die Umfrage mit Audio fest'
              }
            }
          },
          'CERTIFICARAMCO': {
            'TITULO': 'AMCO',
          },
          'CERTIFICARTRABADIG': {
            'TITULO': 'Anständige Arbeit',
          },
          'CERTIFICARADICPRIEMPL': {
            'TITULO': 'Erster Job',
          },
          'CERTIFICAR_C2': {
            'TITULO': 'Izzi',
          },
          'CERTIFICAR35': {
            'TITULO': 'NOM-035-STPS-2018',
            'LANDING': {
              'TITULO': 'WILLKOMMEN BEI NOM-035-STPS-2018',
              'DONE': 'Anwendungsjahr: ',
              'ENTRAR': 'Start'
            },
            'STEPS': {
              'STP1': {
                'WIZBT': 'Sprachen',
                'TITULO': 'Sprachen',
                'SUBTI': 'Sprachenauswahl'
              },
              'STP2': {
                'WIZBT': 'Für alle Praxen',
                'TITULO': 'Für alle Praktiken',
                'SUBTI': 'Fügen Sie die For All Practices Ihres Unternehmens für die Umfrage ein'
              },
              'STP3': {
                'WIZBT': 'Demographie',
                'TITULO': 'Demografie',
                'SUBTI': 'Fügen Sie die demographischen Informationen ein, die in der Umfrage angezeigt werden sollen'
              },
              'STP4': {
                'WIZBT': 'Verkaufshilfsmittel',
                'TITULO': 'Verkaufshilfsmittel',
                'SUBTI': 'Zusatzfragen für die Umfrage einfügen'
              },
              'STP5': {
                'WIZBT': 'Teilnehmer',
                'TITULO': 'Teilnehmer',
                'SUBTI': 'Sie haben Ihre Teilnehmerdatenbank nicht geladen'
              },
              'STP6': {
                'WIZBT': 'Umfrage planen',
                'TITULO': 'Zeitplan für die Umfrage',
                'SUBTI': 'Start- und Erinnerungsdaten der Umfrage einplanen'
              },
              'STP7': {
                'WIZBT': 'Mail-Absender',
                'TITULO': 'Mail-Absender',
                'SUBTI': 'Senden Sie die Umfrageeinladung an Ihre Mitarbeiter'
              },
              'STP8': {
                'WIZBT': 'Umfrage abschließen',
                'TITULO': 'Umfrage-Abschluss',
                'SUBTI': 'Fortschritt vor Abschluss der Umfrage'
              },'STP9':{
                'WIZBT': 'Kommunikationsplan',
                'TITULO': 'Kommunikationsplan',
                'SUBTI': 'Senden Sie die Einladung zur Umfrage an Ihre Mitarbeiter'
              },'STP10':{
                'WIZBT': 'Teilnehmer',
                'TITULO': 'Teilnehmer',
                'SUBTI': 'Machen Sie sich bereit für die NOM-035-STPS-2018 Umfrage'
              }
            }
          },
          'PULSE': {
            'TITULO': 'Pulse Check',
            'LANDING': {
              'TITULO': 'WILLKOMMEN BEI PULSE CHECK',
              'DONE': 'Anwendungsjahr: ',
              'ENTRAR': 'Start'
            },
            'STEPS': {
              // 'STP1': {
              // 'WIZBT': 'Sprachen',
              // 'TITULO': 'Sprachen',
              // 'SUBTI': 'Sprachenauswahl',
              // },
              // 'STP1-1': {
              // 'WIZBT': 'Anweisungen',
              // 'TITULO': 'Anweisungen',
              // 'SUBTI': 'Anweisungsauswahl'
              // },
              // 'STP2': {
              // 'WIZBT': 'Für alle Praxen',
              // 'TITULO': 'Für alle Praktiken',
              // 'SUBTI': 'Geben Sie die 'Für alle Praxen' Ihres Unternehmens für die Umfrage ein'
              // },
              // 'STP3': {
              // 'WIZBT': 'Demografische Daten',
              // 'TITULO': 'Demografie',
              // 'SUBTI': 'Fügen Sie die demografischen Informationen ein, die in der Umfrage angezeigt werden sollen'
              // },
              // 'STP3-1': {
              // 'WIZBT': 'Offene Fragen',
              // 'TITULO': 'Offene Fragen',
              // 'SUBTI': 'Einfügen der offenen Fragen'
              // },
              // 'STP4': {
              // 'WIZBT': 'Verkaufshilfsmittel',
              // 'TITULO': 'Zusatzfragen',
              // 'SUBTI': 'Zusatzfragen für die Umfrage einfügen'
              // },
              // 'STP5': {
              // 'WIZBT': 'Teilnehmer',
              // 'TITULO': 'Teilnehmer',
              // 'SUBTI': 'Laden Sie die Datenbank Ihrer Firmenmitarbeiter hoch'
              // },
              'STP6': {
                'WIZBT': 'Umfrage terminieren',
                'TITULO': 'Umfrage terminieren',
                'SUBTI': 'Umfragetermine einplanen Pulse Check'
              },
              'STP7': {
                'WIZBT': 'Mail-Absender',
                'TITULO': 'Mail-Absender',
                'SUBTI': 'Senden Sie die Umfrageeinladung an Ihre Mitarbeiter'
              },
              'STP8': {
                'WIZBT': 'Umfrageverlauf',
                'TITULO': 'Umfrage-Fortschritt',
                'SUBTI': 'Fortschritt der Umfragen überprüfen Pulse Check',
              }
            }
          },
          'CERTIFICAR_C1': {
            'TITULO': 'Alternativ zertifizieren',
            'LANDING': {
              'TITULO': 'WELCOME TO ALTERNATIVE CERTIFY',
              'DONE': 'Antragsjahr: ',
              'ENTRAR': 'Start'
            }
          },
          'MEDIR': {
            'TITULO': 'Messung',
            'LANDING': {
              'TITULO': 'WILLKOMMEN BEI MEASUREMENT',
              'DONE': 'Anwendungsjahr: ',
              'ENTRAR': 'Start'
            }
          },
          'MEDIR_M1': {
            'TITULO': 'Messung erweitert',
            'LANDING': {
              'TITULO': 'WILLKOMMEN BEI MEASUREMENT ENHANCED',
              'DONE': 'Anwendungsjahr: ',
              'ENTRAR': 'Start'
            }
          },
          'MEDIR_M2': {
            'TITULO': 'Messung + MST',
            'LANDING': {
              'TITULO': 'WILLKOMMEN BEI MEASUREMENT + MST',
              'DONE': 'Anwendungsjahr: ',
              'ENTRAR': 'Start'
            }
          },
          'MEDIR_M3': {
            'TITULO': 'Messung nach Bereichen',
            'LANDING': {
              'TITULO': 'WILLKOMMEN ZUR MESSUNG NACH BEREICHEN',
              'DONE': 'Anwendungsjahr: ',
              'ENTRAR': 'Start'
            }
          },
          'MEDIR_M4': {
            'TITULO': 'Messung durch Leiter',
            'LANDING': {
              'TITULO': 'WILLKOMMEN BEI MEASUREMENT BY LEADERS',
              'DONE': 'Anwendungsjahr: ',
              'ENTRAR': 'Start'
            }
          },
          'MEDIR_M5': {
            'TITULO': 'Messung nach Dimensionen',
            'LANDING': {
              'TITULO': 'WILLKOMMEN BEI DER MESSUNG NACH DIMENSIONEN',
              'DONE': 'Anwendungsjahr: ',
              'ENTRAR': 'Start'
            }
          },
          'MEDIR_M6': {
            'TITULO': 'Messung zum Zertifizieren',
            'LANDING': {
              'TITULO': 'WILLKOMMEN BEI MESSUNG ZUR ZERTIFIZIERUNG',
              'DONE': 'Anwendungsjahr: ',
              'ENTRAR': 'Start'
            }
          },
          'MEDIR_M9': {
            'TITULO': 'Innmotion-Umfrage',
            'LANDING': {
              'TITULO': 'WELCOME TO INNMOTION SURVEY',
              'DONE': 'Anwendungsjahr: ',
              'ENTRAR': 'Start'
            }
          },
          'FOCUS':{
            'TITULO': 'Fokusbereich',
            'LANDING': {
              'TITULO': 'WILLKOMMEN IM FOKUSBEREICH',
              'DONE': 'Anwendungsjahr: ',
              'ENTRAR': 'Start'
            },
            'STEPS': {
              'STP1': {
                'WIZBT': 'Sprachen',
                'TITULO': 'Sprachen',
                'SUBTI': 'Sprachenauswahl'
              },
              'STP2': {
                'WIZBT': 'Gruppen verwalten',
                'TITULO': 'Gruppen verwalten',
                'SUBTI': 'Fügen Sie die For-All-Praktiken Ihres Unternehmens für die Umfrage ein'
              },
              'STP3': {
                'WIZBT': 'Umfragen verwalten',
                'TITULO': 'Umfragen verwalten',
                'SUBTI': 'Fügen Sie die demografischen Informationen ein, die in der Umfrage angezeigt werden sollen'
              },
              'STP4': {
                'WIZBT': 'Umfragetafel',
                'TITULO': 'Umfragetafel',
                'SUBTI': 'Zusätzliche Fragen für die Umfrage einfügen'
              }
            }
          },
          'LEADER_GO':{
            'TITULO_ADMIN': 'LEADER GO® WELCOME VERWALTER',
            'TITULO': 'LEADER GO® WILLKOMMEN',
            'TITULO_PRODUCT':'Anführer Go® Verwalter',
            'TITULO_PRODUCT2':'Anführer Go®',
            'LANDING': {
              'TITULO': 'WILLKOMMEN BEI LEADER GO',
              'DONE': 'Jahr der Anwendung: ',
              'ENTRAR': 'Start'
            },
            'STEPS': {
              'STP1': {
                'WIZBT': 'Sprachen',
                'TITULO': 'Sprachen',
                'SUBTI': 'Auswahl der Sprache'
              },
              'STP2': {
                'WIZBT': 'Leader-Auswahl',
              'TITULO': 'Leiter-Auswahl',
              'SUBTI': 'Leiterauswahl',
              },
              'STP3': {
                'WIZBT': 'Kommunikation',
              'TITULO': 'Kommunikation',
              'SUBTI': 'Login zum Bearbeiten der Mails',
              },
              'STP4': {
                'WIZBT': 'Bestätigung',
              'TITULO': 'Bestätigung',
              'SUBTI': 'Eingabe zur Bestätigung des Versands von E-Mails',
              },
              'STP5': {
                'WIZBT': 'Vorlauf',
                'TITULO': 'Vorlauf',
                'SUBTI': 'Vorlauf'
              }
            }

          },
          'ACTION_GO':{
            'TITULO_ADMIN': 'ACTION GO® WELCOME ADMINISTRATOR',
            'TITULO': 'ACTION GO® WELCOME',
            'TITULO_PRODUCT':'Action GO®-Verwalter',
            'TITULO_PRODUCT2':'Action GO®',
          },
          'LANDING_REQUERIMIENTOSV3':{
            'TITULO':'Technische Anforderungen',
            'EXTERNAL_PORTAL':'Externe RT-Url kopieren',
            'COPYA_MESSAGE':'Die url wurde in die Zwischenablage kopiert',

          },
          'GOFLOW':{
            'TITULO': 'GoFlow-Ergebnisse',
          },
        }
      }
};
